import React, { useState, useEffect } from 'react';
import { RefreshCcw } from 'lucide-react';
import walletService from '../../services/shop/walletService';

const SkeletonLoader = () => {
  return (
    <>
      {/* Header con dimensión fija */}
      {/* <div className="flex justify-between items-center mb-6  ">
        <div className="h-6 bg-red-800 rounded w-24"></div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-red-800 rounded"></div>
          <div className="w-4 h-4 bg-red-800 rounded"></div>
        </div>
      </div> */}

      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-bold text-white">Mi Billetera</h3>
        <div className="flex items-center gap-2">
          <button
             className="text-white hover:text-yellow-300 transition-colors"
          >
            {/* <RefreshCcw className="w-4 h-4" /> */}
          </button>
          {/* <button
             className="text-white hover:text-yellow-300 transition-colors"
          >
            ✕
          </button> */}
        </div>
      </div>

      <div className="space-y-4">
        {/* Comisiones Pendientes - altura fija */}
        <div className="bg-gradient-to-b from-yellow-400 to-yellow-500 h-20 p-4 rounded-xl shadow-lg border border-yellow-300 animate-pulse">
          <div className="h-4 bg-yellow-300/50 rounded w-36 mb-2"></div>
          <div className="h-7 bg-yellow-300/50 rounded w-20"></div>
        </div>

        {/* Comisiones Disponibles - altura fija */}
        <div className="bg-gradient-to-b from-blue-400 to-blue-500 h-20 p-4 rounded-xl shadow-lg border border-blue-300 animate-pulse">
          <div className="h-4 bg-blue-300/50 rounded w-36 mb-2"></div>
          <div className="h-7 bg-blue-300/50 rounded w-20"></div>
        </div>

        {/* Últimos Movimientos */}
        <div className="bg-red-950 bg-opacity-40 p-4 rounded-xl border border-red-800">
          <div className="h-5 bg-red-800 rounded w-40 mb-3"></div>
          {/* Este contenedor puede crecer según el contenido */}
          <div className="space-y-2">
            {[...Array(1)].map((_, index) => (
              <div
                key={index}
                className="flex justify-between items-center p-4 bg-gradient-to-r from-red-950 to-red-900 rounded-lg border border-red-800"
              >
                <div className="flex flex-col space-y-1">
                  <div className="h-3 bg-red-800/50 rounded w-24"></div>
                  <div className="h-3 bg-red-800/50 rounded w-16"></div>
                  <div className="h-3 bg-red-800/50 rounded w-20"></div>
                </div>
                <div className="h-4 bg-red-800/50 rounded w-16"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
 

const WalletModal = ({ setShowWalletDetails }) => {
  const [walletData, setWalletData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadWalletData = async () => {
      try {
        setLoading(true);
        const response = await walletService.getWalletSummary(
          window.userId,
          window.localId
        );
          console.log(response)
        if (response.data.success) {
          setWalletData(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError('Error cargando datos de la billetera');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadWalletData();
  }, []);

  const refreshWallet = async () => {
    setLoading(true);
    try {
      const response = await walletService.getWalletSummary(
        window.userId,
        window.localId
      );
                console.log(response);

      if (response.data.success) {
        setWalletData(response.data.data);
      }
    } catch (err) {
      console.error('Error refreshing wallet:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50">
        <div className="bg-gradient-to-b from-red-800 to-red-900 rounded-xl p-6 w-full max-w-sm shadow-xl border border-red-700">
          <SkeletonLoader />
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50"
      onClick={() => setShowWalletDetails(false)}
    >
      <div
        className="bg-gradient-to-b from-red-800 to-red-900 rounded-xl p-6 w-full max-w-sm shadow-xl border border-red-700"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-white">Mi Billetera</h3>
          <div className="flex items-center gap-2">
            <button
              onClick={refreshWallet}
              className="text-white hover:text-yellow-300 transition-colors"
            >
              <RefreshCcw className="w-4 h-4" />
            </button>
            <button
              onClick={() => setShowWalletDetails(false)}
              className="text-white hover:text-yellow-300 transition-colors"
            >
              ✕
            </button>
          </div>
        </div>

        <div className="space-y-4">
          {/* Comisiones Pendientes */}
          <div className="bg-gradient-to-b from-yellow-400 to-yellow-500 p-4 rounded-xl shadow-lg border border-yellow-300">
            <p className="text-red-900 text-sm font-semibold">Comisiones Pendientes</p>
            <p className="text-red-900 text-2xl font-bold">
              {walletService.formatAmount(walletData?.balance?.pendiente || 0)}
            </p>
          </div>

          {/* Comisiones Disponibles */}
          <div className="bg-gradient-to-b from-blue-400 to-blue-500 p-4 rounded-xl shadow-lg border border-blue-300">
            <p className="text-white text-sm font-semibold">Comisiones Disponibles</p>
            <p className="text-white text-2xl font-bold">
              {walletService.formatAmount(walletData?.balance?.disponible || 0)}
            </p>
          </div>

          {/* Últimos Movimientos */}
          <div className="bg-red-950 bg-opacity-40 p-4 rounded-xl border border-red-800">
            <h4 className="text-yellow-300 font-medium mb-3">
              Últimos Movimientos
            </h4>
            <div className="space-y-2">
              {walletData?.movimientos?.map((mov) => {
                const statusBadge = walletService.getStatusBadge(mov.estado);
                return (
                  <div
                    key={mov.id}
                    className="flex justify-between items-center p-3 bg-gradient-to-r from-red-950 to-red-900 rounded-lg border border-red-800"
                  >
                    <div className="flex flex-col">
                      <span className="text-white text-sm">{mov.tipo}</span>
                      <span className={`text-xs ${statusBadge.color}`}>
                        {statusBadge.icon} {statusBadge.text}
                      </span>
                      <span className="text-gray-400 text-xs">
                        {walletService.formatDate(mov.fecha)}
                      </span>
                    </div>
                    <span className={`font-medium ${statusBadge.color}`}>
                      {walletService.formatAmount(mov.monto)}
                    </span>
                  </div>
                );
              })}
              {(!walletData?.movimientos || walletData.movimientos.length === 0) && (
                <div className="text-center text-gray-400 py-4">
                  No hay movimientos para mostrar
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletModal;